import classNames from 'classnames';

const cx = classNames;

function Checkout() {
    return (
        <div className={cx('bg-blue-100 text-8xl font-semibold w-screen h-[600px] flex items-center justify-center')}>
            CHECKOUT
        </div>
    );
}

export default Checkout;
